import { render } from "./np-show-less.vue?vue&type=template&id=4fbbb1d0"
import script from "./np-show-less.vue?vue&type=script&lang=js"
export * from "./np-show-less.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__